import React, { useState } from 'react';
import '../../styles.css';

function DrivetrainParameterEditor({ group, groupIdx, setTabs }) {
  const [showDrivetrainConfig, setShowDrivetrainConfig] = useState(false);
  const [drivetrainConfig, setDrivetrainConfig] = useState({
    dropGear: group.params.some(p => p.name === 'Drop Gear'),
    numGears: group.params.find(p => p.name === 'Number of Gears')?.value || '6',
    driveType: group.params.find(p => p.name === 'Drive Type')?.value || 'RWD'
  });

  const updateDrivetrainConfig = () => {
    const updatedParams = [
      {
        name: 'Final Drive',
        unit: '',
        min: '2',
        max: '12',
        step: '0.001',
        value: group.params.find(p => p.name === 'Final Drive')?.value || ''
      }
    ];

    if (drivetrainConfig.dropGear) {
      updatedParams.push({
        name: 'Drop Gear',
        unit: '',
        min: '0.5',
        max: '2',
        step: '0.001',
        value: group.params.find(p => p.name === 'Drop Gear')?.value || ''
      });
    }

    const numGears = parseInt(drivetrainConfig.numGears) || 6;
    for (let i = 1; i <= numGears; i++) {
      updatedParams.push({
        name: `Gear Ratio ${i}`,
        unit: '',
        min: '0.5',
        max: i === 1 ? '5' : i === 2 ? '4' : i === 3 ? '3' : i === 4 ? '2.5' : i === 5 ? '2' : '1.5',
        step: '0.001',
        value: group.params.find(p => p.name === `Gear Ratio ${i}`)?.value || ''
      });
    }

    updatedParams.push({
      name: 'Drive Type',
      unit: 'text',
      type: 'select',
      options: ['RWD', 'FWD', 'AWD'],
      value: drivetrainConfig.driveType
    });

    updatedParams.push({
      name: 'Number of Gears',
      unit: 'text',
      type: 'select',
      options: ['1', '2', '3', '4', '5', '6', '7', '8'],
      value: drivetrainConfig.numGears
    });

    setTabs(prevTabs => {
      const updatedTabs = [...prevTabs];
      updatedTabs.find(tab => tab.name === 'Drivetrain').groups[groupIdx].params = updatedParams;
      return updatedTabs;
    });
    setShowDrivetrainConfig(false);
  };

  return (
    <>
      <i
        className="material-icons param-edit-icon"
        onClick={() => setShowDrivetrainConfig(true)}
      >
        settings
      </i>
      <div className="param-action-placeholder" />
      {showDrivetrainConfig && (
        <div className="overlay-card">
          <div className="card-container">
            <div className="page-title">
              <h2>Edit Drivetrain Configuration</h2>
              <button onClick={() => setShowDrivetrainConfig(false)} className="close-button">✕</button>
            </div>
            <label>
              Final Drive (Always Included)
              <input type="checkbox" checked={true} disabled />
            </label>
            <label>
              Drop Gear
              <input
                type="checkbox"
                checked={drivetrainConfig.dropGear}
                onChange={e => setDrivetrainConfig({ ...drivetrainConfig, dropGear: e.target.checked })}
              />
            </label>
            <select
              value={drivetrainConfig.numGears}
              onChange={e => setDrivetrainConfig({ ...drivetrainConfig, numGears: e.target.value })}
              className="event-editor-select"
            >
              {['1', '2', '3', '4', '5', '6', '7', '8'].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
            <select
              value={drivetrainConfig.driveType}
              onChange={e => setDrivetrainConfig({ ...drivetrainConfig, driveType: e.target.value })}
              className="event-editor-select"
            >
              {['RWD', 'FWD', 'AWD'].map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
            <div className="event-editor-actions">
              <button onClick={updateDrivetrainConfig} className="btn btn-save">Save</button>
              <button onClick={() => setShowDrivetrainConfig(false)} className="btn btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DrivetrainParameterEditor;